import script from "./BadgesFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgesFrame.vue?vue&type=script&setup=true&lang=js"

import "./BadgesFrame.vue?vue&type=style&index=0&id=51850ab7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51850ab7"]])

export default __exports__